<div class="bg login-bg">
    <span class="shape circle grey"></span>
    <span class="shape circle yellow-big"></span>
    <span class="shape circle green"></span>

    <span class="shape square pink"></span>
    <span class="shape square yellow-small"></span>

    <ng-content></ng-content>
</div>
